import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface SystemVersion {
  id: string;
  version: string;
  notes: string | null;
  migrated_at: string | null;
  seeded_at: string | null;
  created_by: string | null;
  tenant_id: string;
  created_at: string;
  updated_at: string;
}

export interface CurrentSystemVersion {
  current: SystemVersion | null;
  last_migration_at: string | null;
  last_seed_at: string | null;
  app_version: string | null;
}

export const GetCurrentSystemVersion = async (): Promise<
  ApiResponse<CurrentSystemVersion>
> => {
  try {
    const response = await axiosClientv1.get(`/system-version`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to load current system version.",
      data: { current: null, last_migration_at: null, last_seed_at: null },
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const GetSystemVersions = async (): Promise<
  ApiResponse<SystemVersion[]>
> => {
  try {
    const response = await axiosClientv1.get(`/system-versions`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load system versions.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateSystemVersion = async (payload: {
  version: string;
  notes?: string;
}): Promise<ApiResponse<SystemVersion>> => {
  try {
    const response = await axiosClientv1.post(
      `/system-version/create`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to create system version.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateSystemVersion = async (payload: {
  id: string;
  version?: string;
  notes?: string;
}): Promise<ApiResponse<SystemVersion>> => {
  try {
    const response = await axiosClientv1.post(
      `/system-version/update`,
      payload,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update system version.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteSystemVersion = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/system-version/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to delete system version.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const RunMigrations = async (): Promise<
  ApiResponse<{ output: string }>
> => {
  try {
    const response = await axiosClientv1.post(`/database/migrate`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to run migrations.",
      data: { output: "" },
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const RunSeeds = async (): Promise<ApiResponse<{ output: string }>> => {
  try {
    const response = await axiosClientv1.post(`/database/seed`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to run seeds.",
      data: { output: "" },
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};
